import React from 'react';
import { Box, Typography } from '@lucid/lego';
import { useStore } from '../../../store/store';
import Table from './Table/Table';
import claimsData from '../../../data/claimsCenter/claims.json';
import { Claim } from './Table/utils';

const TrackClaim: React.FC = () => {
  const theme = useStore((state) => state.theme);
  const claims = claimsData.data as Claim[];

  return (
    <Box>
      <Typography variant="headline" size="small" color="primary-1" theme={theme}>
        Track Claim
      </Typography>
      <Box pt={24}>
        <Table theme={theme} data={claims} />
      </Box>
    </Box>
  );
};

export default TrackClaim;
